<template>
    <v-container fluid>
        <div class="modal-padding cp3-modal fix-error-message">
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="show-drop-down">
                        <div class="label-data edit-student-label">Edit Student:</div>
                        <div class="field-data">
                            <v-text-field v-model="name" class="fix-200"></v-text-field>
                            <InputError :data='error.name' />
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="12">
                    <div class="show-drop-down">
                        <div class="label-data edit-student-label">Email ID:</div>
                        <div class="field-data">
                            <v-text-field v-model="email" class="fix-200"></v-text-field>
                            <InputError :data='error.email' />
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="12">
                    <div class="show-drop-down">
                        <div class="label-data edit-student-label">Roll Number:</div>
                        <div class="field-data">
                            <v-text-field v-model="rollNumber" min="1"
                                :disabled="data && data.is_approved && data.roll_number ? true : false" class="fix-200"
                                type="number" @keydown.space.prevent
                                @keypress="allowedOnlyNumber($event, true)"></v-text-field>
                            <InputError :data='error.roll_number' />
                        </div>
                    </div>
                </v-col>

            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="bottom-btn left-btn">
                        <v-btn :loading="saveLoading" @click="updateStudent(false)" class="right-btn cust-btn"
                            color="primary">Done</v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";
export default {
    name: 'EditStudentBatchDetails',
    props: ['onClose', 'data', 'status'],
    data() {
        return {
            name: this.data ? this.data.name : '',
            email: this.data ? this.data.email : '',
            selectedTargetYear: this.data && this.data.class_code ? this.data.class_code.includes('##') ? Number(this.data.class_code.split('##')[1]) : Number(this.data.class_code) : null,
            approvalLoading: false,
            saveLoading: false,
            centers: [],
            classes: [],
            error: {
                name: {
                    type: null,
                    message: 'Please enter name'
                },
                email: {
                    type: null,
                    message: 'Please enter email'
                },
                class: {
                    type: null,
                    message: 'Please select target year'
                },

                roll_number: {
                    type: null,
                    message: "Roll number must be a maximum of 10 digits."
                }
            },
            onlineUser: false,
            rollNumber: this.data && this.data.roll_number ? this.data.roll_number : null,
            selectedTargetExam: this.data && this.data.class_code ? this.data.class_code.includes('##') ? this.data.class_code.split('##')[0] : this.data.class_code : null,
            examList: constants.TARGET_EXAM.map((c) => c),
        }
    },
    methods: {
        ...mapActions({
            updateExternalUser: "userStore/updateExternalUser",
            getClasses: "userStore/getClasses",

        }),
        validate() {
            this.email = this.removeWhiteSpacesFromEmail(this.email);
            let isValid = true;
            this.error.name.type = null;
            this.error.email.type = null;
            this.error.class.type = null;

            if ((!this.name) || this.name.trim().length < 1) {
                this.error.name.type = 'error';
                this.error.name.message = 'Please enter name';
                isValid = false;
            }
            if (!this.email || this.email.length < 1) {

                this.error.email.type = 'error';
                this.error.email.message = 'Please enter email ID.';
                isValid = false;
            }
            else if (!this.isValidEmail(this.email)) {

                this.error.email.type = 'error';
                this.error.email.message = 'Please enter a valid email ID.';
                isValid = false;
            }
            // if ((!this.selectedTargetYear) && this.onlineUser) {
            //     console.log("this.selectedTargetYear",this.selectedTargetYear);
            //     this.error.class.type = 'error';
            //     isValid = false;
            // }
            // if ((!this.selectedTargetExam) && this.onlineUser) {
            //     console.log("this.selectedTargetExam",this.selectedTargetExam);
            //     this.error.class.type = 'error';
            //     isValid = false;
            // }

            if ((this.rollNumber) && this.rollNumber.length > 10) {
                this.error.roll_number.type = 'error';
                isValid = false;
            }
            return isValid;
        },



        updateStudent() {
            this.loading = true;
            if (this.validate()) {
                this.saveLoading = true;
                const payload = {
                    user_id: this.data.id,
                    name: this.name.trim(),
                    email: this.email,
                    role_id: this.roleIds.ST,
                    roll_number: this.rollNumber
                }
                if (this.selectedTargetYear) {
                    payload.target_year = this.selectedTargetYear.toString();
                    payload.class = this.selectedTargetYear.toString();
                }
                if (this.selectedTargetExam) {
                    payload.target_exam = this.selectedTargetExam;
                }
                this.updateExternalUser(payload)
                    .then(response => {
                        this.loading = false;
                        this.email = '',
                            this.name = '',
                            this.$toasted.success(`Student Updated Successfully`, { icon: 'check_circle' });
                        this.saveLoading = false;

                        this.loading = false;

                        this.onClose({ status: false, reload: true });

                    })
                    .catch(err => {
                        this.loading = false;
                        this.saveLoading = false;

                    });


            } else {
                this.loading = false;
            }
        },
        requestGetClasses() {
            this.getClasses().then(response => {
                this.loading = false;
                this.classes = response
                    .map(x => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.class_code;
                        return c;

                    })

            })
                .catch(err => {
                    this.loading = false;
                });
        },

    },
    mounted() {
        this.onlineUser = this.user.institute === constants.ONLINE_INSTITUTE_ID ? false : true
        this.requestGetClasses();
    },
    computed: {
        ...mapState("userStore", ["user"]),
    },
    watch: {
        status(val) {
            this.name = this.data ? this.data.name : null;
            this.email = this.data ? this.data.email : null;
            this.selectedTargetYear = this.data && this.data.class_code ? this.data.class_code.includes('##') ? Number(this.data.class_code.split('##')[1]) : Number(this.data.class_code) : null;
            this.selectedTargetExam = this.data && this.data.class_code ? this.data.class_code.includes('##') ? this.data.class_code.split('##')[0] : this.data.class_code : null;
            this.rollNumber = this.data && this.data.roll_number ? this.data.roll_number : null;
        },
        name() {
            this.error.name.type = null;
        },
        email() {
            this.error.email.type = null;
        },
        selectedTargetYear() {
            this.error.class.type = null
        },
        selectedTargetExam() {
            this.error.class.type = null
        },
        rollNumber() {
            this.error.roll_number.type = null;
        }
    }
}
</script>
<style lang="scss"></style>
